export const title = 'システム開発のプロが発注成功を手助けする【発注ラウンジ】';
export const shortTitle = '発注ラウンジTOP';
export const hnaviTitle =
  'システム開発会社やアプリ開発会社を探すなら比較・見積もりの【発注ナビ】';
export const hnaviShortTitle = '発注ナビTOP';

export const basePath = '/knowledge';
export const categoryBasePath = `${basePath}/category`;
export const caseStudyBasePath = `${basePath}/interview`;
export const interviewBasePath = `${basePath}/interview`;
export const baseBaseUrl = `https://${
  process.env.NEXT_PUBLIC_FRONT_SERVICE_HOST || process.env.FRONT_SERVICE_HOST
}`;
export const baseUrl = `${baseBaseUrl}${basePath}`;
export const hnaviBaseContentCategories = {
  enterprise: '業務システム',
  web: 'WEBシステム',
  spa: 'アプリ開発',
  hp: 'ホームページ制作',
  ecommerce: 'ECサイト構築',
  cms: 'CMS構築',
  server: 'サーバー・クラウド',
  asp: 'ASP・パッケージ',
  embedded: '組み込みシステム開発',
  consulting: 'コンサル・PM',
  marketing: 'WEBマーケティング',
  movie: '動画制作',
  xr: 'XR・メタバース',
};

export const wpCustomFieldNames = {
  hnaviMainCategory: 'hnavi_main_category',
  hnaviReferenceKey: 'hnavi_reference_key',
};
export const casestudyTypes = {
  casestudy: '発注ナビ活用事例',
  'corporation-casestudy': '発注ナビ導入事例',
} as const;
export const hnaviSearchMethod = 'get';
export const hnaviSearchName = 'search[text]';
export const lpUrl1 = '/lp/system2b/?argument=bzcUT99h&dmai=a62a80c49928e7';
export const numbers = {
  matchCount: '32000',
  developerCount: '9000',
  matchRate: '92%',
  technologyCount: '319',
};
export const gtm = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-PCM3NL');`;
export const gtmNoScript = `<iframe src="//www.googletagmanager.com/ns.html?id=GTM-PCM3NL"height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
export const metaKeywords =
  '発注ナビ,発注,比較,見積,見積もり,会社,探す,外注,相談,受託,システム,システム開発,開発会社,ビジネスマッチング';
export const isrRevalidateSec = 600;
export const buyerServiceUrl = `https://${process.env.NEXT_PUBLIC_BUYER_SERVICE_HOST}`;
export const glossarySlug = 'glossary';
